import { render } from "./menu-dialog.vue?vue&type=template&id=03e45ae2&scoped=true&ts=true"
import script from "./menu-dialog.vue?vue&type=script&lang=ts"
export * from "./menu-dialog.vue?vue&type=script&lang=ts"

import "./menu-dialog.vue?vue&type=style&index=0&id=03e45ae2&lang=css&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e45ae2"]])

export default __exports__